import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
    promotionSection: {
        position: 'relative',
        paddingTop: 65,
        paddingBottom: 65
    },
    promotionBox: {
        marginBottom: 24
    },
    showMoreButtonBox: {
        display: 'flex',
        justifyContent: 'center'
    },
    promotionCardContainer: {
        width: 197,
        scrollSnapAlign: 'center'
    },
    motionIconBox: {
        position: 'absolute',
        width: 150,
        bottom: 0,
        right: 200
    },
    motionIconBoxBis: {
        position: 'absolute',
        width: 150,
        top: 20,
        left: 60
    },
}))
